module.exports = __webpack_public_path__ + "img/group5Copy6@2x.89b072e7.png";